export const typeOptions = [
  { label: 'IP', value: 2 },
  { label: '设备号', value: 3 },
  // { label: '会员ID', value: 4 },
  //   { label: '会员账号', value: 'username' },
]
export const methodOptions = [
  { label: '限制注册', value: 1 },
  { label: '限制登录', value: 2 },
  { label: '限制提现', value: 3 },
]
